import { useTranslation } from 'react-i18next';

const FORMATS = [
  { icon: 'ri-community-line' },
  { icon: 'ri-play-circle-line' },
  { icon: 'ri-calendar-check-line' },
];

function renderParagraphs(text: string, className: string) {
  return text
    .split(/(?:\r?\n){2,}/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0)
    .map((part, index) => (
      <p key={index} className={className}>
        {part}
      </p>
    ));
}

export default function StudyFormats() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          <div>
            <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
              {t('butlerTrainingSchool.formats.label')}
            </p>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
              {t('butlerTrainingSchool.formats.title')}
            </h2>
            <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
              {t('butlerTrainingSchool.formats.titleEn')}
            </p>
            <div className="gold-line mb-6"></div>
            {renderParagraphs(
              t('butlerTrainingSchool.formats.lead'),
              'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed',
            )}
          </div>

          <div className="relative w-full aspect-[4/3] overflow-hidden">
            <img
              src="/images/generated/about-classroom-2026.jpg"
              alt={t('butlerTrainingSchool.formats.imgAlt')}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {FORMATS.map((format, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-6 md:p-8 flex flex-col items-start cursor-default"
            >
              <div className="w-12 h-12 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center mb-5">
                <i className={`${format.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                {t(`butlerTrainingSchool.formats.${idx}.title`)}
              </h3>
              {renderParagraphs(
                t(`butlerTrainingSchool.formats.${idx}.desc`),
                'text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed',
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 border-l-2 border-accent-500/40 bg-background-50 p-6 md:p-8 max-w-[900px]">
          <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
            {t('butlerTrainingSchool.formats.working.title')}
          </h3>
          {renderParagraphs(
            t('butlerTrainingSchool.formats.working.desc'),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed',
          )}
        </div>
      </div>
    </section>
  );
}
